import { BrokerId } from '../core/broker/broker.service';

export class Authorization {
    constructor(
      public authorizedAdminAgent: Boolean = false,
      public authorizedAdminIT: Boolean = false,
      public authorizedAgent: Boolean = false,
      public allowedBrokers: BrokerId[] = []
    ) {}
  }
